import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <main className="not-found">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1 className="error-title">Page Not Found</h1>
        <p className="error-message">
          The page you're looking for doesn't exist or has been moved.
          Maybe it's off building something new in the lab.
        </p>
        <div className="error-actions">
          <Link to="/" className="btn btn-primary">
            Go Home →
          </Link>
          <Link to="/labs" className="btn btn-secondary">
            Explore Labs
          </Link>
        </div>
      </div>
      
      <div className="not-found-visual">
        <div className="orbital-error">
          <div className="orbit orbit-1"></div>
          <div className="orbit orbit-2"></div>
          <div className="orbit orbit-3"></div>
          <div className="core"></div>
        </div>
      </div>
    </main>
  );
};

export default NotFound;